import { useCallback, useEffect, useRef } from 'react'

export const getStyleElement = (id = Math.random().toString(36).substring(2)) => {
  const elementId = `use-global-style-${id}`
  let styleElement = document.getElementById(elementId)
  if (styleElement) {
    return styleElement
  }
  styleElement = document.createElement('style')
  styleElement.id = elementId
  document.head.appendChild(styleElement)

  return styleElement
}

export const useGlobalScopedStyle = (scopeId: string, styleElementId: string) => {
  const styleRef = useRef<HTMLStyleElement>(null)

  useEffect(() => {
    const styleElement = getStyleElement(`${scopeId}-${styleElementId}`)
    Object.assign(styleRef, { current: styleElement })
  }, [scopeId, styleElementId])

  const setStyle = useCallback(
    (style: string) => {
      if (styleRef.current) {
        styleRef.current.innerHTML = `#${scopeId} { ${style} }`
      }
    },
    [scopeId],
  )

  const clearStyle = useCallback(() => {
    if (styleRef.current) {
      styleRef.current.innerHTML = ''
    }
  }, [])

  return { setStyle, clearStyle }
}
